import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import AppRoutes from "./routes/AppRoutes";
import { msalInstance } from "./config/authConfig";
import ErrorBoundary from "./components/ErrorBoundary";
import { store } from "./store/store";
import Loader from "./pages/Loader";
import config from "devextreme/core/config";

const licenseKey = process.env.REACT_APP_DEVEXTREME_KEY;
config({ licenseKey });

const App: React.FC = () => {
  // const authState = useSelector((state: RootState) => state.auth);
  // console.log("Redux state in App.tsx:", authState);

  return <Provider store={store}>
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <ErrorBoundary>
        <AppRoutes />
        <Loader></Loader>
      </ErrorBoundary>
    </BrowserRouter>
  </MsalProvider>
</Provider>;
};

export default App;
